import { Scope, Event as SentryEvent, EventHint, Breadcrumb } from "@sentry/browser";
import { ISentryLoggerObjectTree, ISentryUser } from "./types";

export class SentryService {

    constructor(public $objectTree: ISentryLoggerObjectTree, public scopeConfigs: any) {
        this.getScope = this.getScope.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
    }

    /**
     * @description 生成模块Sentry上下文     
     *  
     * @param {String} moduleName 模块的名称，配置在sentry.config.js中的errors里，没有配置的默认取GLOBAL
     * @param {Function} callback scope初始化完成回调
     */
    public getScope(moduleName: string, callback: Function): (scope: Scope) => void {
        var scopeFunc: (scope: Scope) => void = function (scope: Scope) {
            //模块配置
            var scopeConfig = this.scopeConfigs[moduleName]

            //运行时模块名
            var rtModuleName;

            //没有指定配置时，获取默认配置
            if (!scopeConfig) {
                rtModuleName = moduleName;
                scopeConfig = this.scopeConfigs['GLOBAL']
            }
            else {
                rtModuleName = scopeConfig.tags.module ? scopeConfig.tags.module : rtModuleName;
            }

            //设置已配置的Tag
            if (scopeConfig && scopeConfig.tags) {
                angular.forEach(scopeConfig.tags, function (value: string, key: string) {
                    var newValue = value.replace("@module", rtModuleName);
                    scope.setTag(key, newValue);
                })
            }

            //设置已配置的额外信息
            if (scopeConfig && scopeConfig.extras) {
                angular.forEach(scopeConfig.extras, function (value: string, key: string) {
                    var newValue = value.replace("@module", rtModuleName);
                    scope.setExtra(key, newValue);
                })
            }

            // 添加用户信息
            let user = this.getUserInfo();

            if (user) {
                scope.setUser(user);
            }

            //用户自定义错误信息
            if (callback) {
                callback(scope);
            }
        }.bind(this);;

        return scopeFunc;
    }


    /**
     * @desc 获取用户信息，不保证一定拿得到，这里以webtoprint为标准
     */
    public getUserInfo(): ISentryUser | null {
        let user = this.$objectTree.getLoggerUser();

        if (user) {
            let sentryUser: ISentryUser = {};

            if (user.userName) {
                sentryUser.username = user.userName;
            }
            if (user.userMail) {
                sentryUser.email = user.userMail;
            }
            if (user.tokenType) {
                sentryUser.token_type = user.tokenType;
            }
            if (user.accessToken) {
                sentryUser.access_token = user.accessToken;
            }
            if (user.anonymousUserId) {
                sentryUser.anonymous_user_id = user.anonymousUserId;
            }
            if (user.isAnonymous) {
                sentryUser.is_anonymous = user.isAnonymous;
            }

            return sentryUser;
        }

        return null;
    }

}